export const defaultFields1 = [
  'id',
  'createdat',
  'createdby',
  'updatedby',
  'isdeleted',
  'updatedat',
];
export const defaultFields2 = ['date', 'createdat', 'updatedat', 'createdAt', 'updatedAt'];

export const tooltipInfoTitles = {
  plsPermissions: `<ul style="padding-left: 1rem"><li><strong>Allowed</strong> – Field will exist in the JSON object. </li><li><strong>Not Allowed</strong> – Field will be removed from the JSON object. </li><li><strong>Restricted</strong> – Field will exist in the JSON object based on the Allowed Permissions. </li></ul>`,
  plsAllowedPermissions: `<ul style="padding-left: 1rem"><li><strong>When Empty (don't have any permission assigned)</strong> – Field will exist in the JSON object with restricted data. </li><li><strong>When assigned permission(s)</strong> – Field will exist in the JSON object for the given permissions only. </li></ul>`,
  plsReferenceFields: `Depenedent on Permissions' <strong>Restricted</strong> value.</br><ul style="padding-left: 1rem"><li><strong>When Empty</strong> – Field will exist in the JSON object with empty list. </li><li><strong>When selected reference fields</strong> – Field will exist in the JSON object with the selected reference fields only. </li></ul>`,
};

export const filterNotAllowedCollections = [
  'permission',
  'search_history',
  'audit_log',
  'audit_trail',
  'task_stats',
  'docusign_tokens',
  'docusign_activity_tracker',
  'file_activity_tracker',
  'user_activity_tracker',
  'aws_sns_sms_activity_tracker',
  'twilio_sms_activity_tracker',
  'aws_ses_activity_tracker',
  'data_view_activity_tracker',
  'chat_room',
  'message',
  'sendgrid_activity_tracker',
  'socket_io_activity_tracker',
  'text_anonymization_activity',
];
